// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__tz7Mg","menu":"navbar_menu__Ki6qU","downloadBtn":"navbar_downloadBtn__CnDbV","nav_link":"navbar_nav_link__y8RqD","nav_btn":"navbar_nav_btn__1IkjQ"};